// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__XWkMx","savePackageButton":"ClientWallet_savePackageButton__18SiM"};